// Shared helper: buckets a garment's free-text "region" field into one of
// the four geographic zones used across the site, with a fifth catch-all
// for Pan-India and pre-modern / Vedic-era pieces.

export const ZONE_KEYWORDS = {
  North: [
    "punjab",
    "kashmir",
    "rajasthan",
    "uttar pradesh",
    "delhi",
    "himachal",
    "lucknow",
    "jodhpur",
    "uttarakhand",
    "awadh",
    "mughal",
  ],
  South: ["tamil nadu", "kerala", "karnataka", "andhra", "telangana", "patan"],
  East: ["bengal", "odisha", "assam", "bihar", "jharkhand", "nilgiris"],
  West: ["gujarat", "maharashtra", "kutch", "aurangabad"],
};

export const ZONE_ORDER = [
  "North",
  "South",
  "East",
  "West",
  "Pan-India & Ancient",
];

export const getZone = (regionText = "") => {
  const text = regionText.toLowerCase();
  for (const [zone, keywords] of Object.entries(ZONE_KEYWORDS)) {
    if (keywords.some((k) => text.includes(k))) return zone;
  }
  return "Pan-India & Ancient";
};
